import { render, staticRenderFns } from "./ObjectInfo.vue?vue&type=template&id=205cc2ba&"
import script from "./ObjectInfo.vue?vue&type=script&lang=js&"
export * from "./ObjectInfo.vue?vue&type=script&lang=js&"
import style0 from "./ObjectInfo.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBottomNav } from 'vuetify/lib/components/VBottomNav';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBottomNav,VFlex,VIcon,VLayout})
